import { render, staticRenderFns } from "./ComparisonFuel.vue?vue&type=template&id=c07202e8&"
import script from "./ComparisonFuel.vue?vue&type=script&lang=js&"
export * from "./ComparisonFuel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports